"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideSearch = void 0;
var React = require("react");
var downshift_1 = require("downshift");
var TextField_1 = require("@material-ui/core/TextField");
var Paper_1 = require("@material-ui/core/Paper");
var MenuItem_1 = require("@material-ui/core/MenuItem");
var Close_1 = require("@material-ui/icons/Close");
var Search_1 = require("@material-ui/icons/Search");
var styles_1 = require("@/pages/guides/components/GuideSearch/styles");
var core_1 = require("@material-ui/core");
exports.GuideSearch = function (_a) {
    var searchSection = _a.searchSection, setSearchKeywords = _a.setSearchKeywords, setSearchText = _a.setSearchText, searchGuides = _a.searchGuides;
    var searchText = searchSection.searchText, searchKeywords = searchSection.searchKeywords, translate = searchSection.translate;
    function renderInput(inputProps) {
        var InputProps = inputProps.InputProps, ref = inputProps.ref, other = __rest(inputProps, ["InputProps", "ref"]);
        return (React.createElement(TextField_1.default, __assign({ InputProps: __assign({ inputRef: ref }, InputProps) }, other)));
    }
    var renderKeyword = function (item) {
        var suggestion = item.suggestion, index = item.index, itemProps = item.itemProps, highlightedIndex = item.highlightedIndex, selectedItem = item.selectedItem;
        var isHighlighted = highlightedIndex === index;
        var isSelected = (selectedItem || '').indexOf(suggestion) > -1;
        return (React.createElement(MenuItem_1.default, __assign({}, itemProps, { key: suggestion, selected: isHighlighted, component: "div", style: { fontWeight: isSelected ? 500 : 400 } }), suggestion));
    };
    var renderDownShift = function (props) {
        var getInputProps = props.getInputProps, getItemProps = props.getItemProps, getMenuProps = props.getMenuProps, highlightedIndex = props.highlightedIndex, isOpen = props.isOpen, selectedItem = props.selectedItem;
        return (React.createElement("div", null,
            renderInput({
                fullWidth: true,
                onKeyPress: function (ev) {
                    if (ev.key === 'Enter') {
                        setSearchKeywords([]);
                        searchGuides();
                        ev.preventDefault();
                    }
                },
                InputProps: getInputProps({
                    placeholder: translate.searchText,
                    endAdornment: (React.createElement(core_1.InputAdornment, { position: "end" },
                        React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                            searchText.length > 0 && (React.createElement(core_1.IconButton, { onClick: function () {
                                    setSearchText('');
                                    setSearchKeywords([]);
                                    searchGuides();
                                } },
                                React.createElement(Close_1.default, null))),
                            React.createElement(core_1.IconButton, { onClick: function () {
                                    setSearchKeywords([]);
                                    searchGuides();
                                } },
                                React.createElement(Search_1.default, null))))),
                }),
            }),
            React.createElement("div", __assign({}, getMenuProps()), isOpen ? (React.createElement(Paper_1.default, { square: true, elevation: 2 }, searchKeywords.map(function (suggestion, index) {
                return renderKeyword({
                    suggestion: suggestion,
                    index: index,
                    itemProps: getItemProps({ item: suggestion }),
                    highlightedIndex: highlightedIndex,
                    selectedItem: selectedItem,
                });
            }))) : null)));
    };
    var stateChanged = function (state) {
        var inputValue = state.inputValue;
        return inputValue && setSearchText(inputValue);
    };
    return (React.createElement(styles_1.Container, null,
        React.createElement(core_1.NoSsr, null,
            React.createElement(downshift_1.default, { isOpen: searchKeywords.length > 0, selectedItem: searchText, onStateChange: stateChanged }, renderDownShift))));
};
